import React from 'react';
import { ButtonUI, FormLabelUI, InputUI } from '../Interface';
import useParam from '../../context/ParamContext';

const ProjectCompanyContactAddFields = ({ newContactState, resetContactAdd, onAdd }) => {
  const { params } = useParam();
  const { newContact, setNewContact } = newContactState;

  const handleChange = (field, value) => {
    setNewContact((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  return (
    <div className="col-span-full grid grid-cols-4 gap-x-4 gap-y-3 rounded bg-[#E7F3FD] p-2">
      <div className="col-span-4 md:col-span-1">
        <InputUI
          fullWidth
          label={<FormLabelUI text="Kapcsolattartó" />}
          variant="standard"
          value={newContact.name}
          onChange={(e) => handleChange('name', e.target.value)}
        />
      </div>

      {params.SIMPLE_CONTACT_CREATE_SHOW_ROLE_FIELD === 'Y' && (
        <div className="col-span-4 md:col-span-1">
          <InputUI
            fullWidth
            label={<FormLabelUI text="Szerep" />}
            variant="standard"
            value={newContact.role}
            onChange={(e) => handleChange('role', e.target.value)}
          />
        </div>
      )}

      <div className="col-span-4 md:col-span-1">
        <InputUI
          fullWidth
          label={<FormLabelUI text="Telefonszám" />}
          variant="standard"
          value={newContact.phoneNumber}
          onChange={(e) => handleChange('phoneNumber', e.target.value)}
        />
      </div>

      <div className="col-span-4 md:col-span-1">
        <InputUI
          fullWidth
          label={<FormLabelUI text="E-mail cím" />}
          variant="standard"
          value={newContact.email}
          onChange={(e) => handleChange('email', e.target.value)}
        />
      </div>

      <div className="flex gap-3 items-center">
        <ButtonUI text="Mégse" className="bg-primary" size="sm" onClick={resetContactAdd} />
        <ButtonUI text="Hozzáadás" className="bg-success" size="sm" onClick={onAdd} />
      </div>
    </div>
  );
};

export default ProjectCompanyContactAddFields;
